import React from 'react'

export const MainNavLayout = ({ children }) => {
  return (
    <div className="content">
      <nav>{children}</nav>
    </div>
  )
}
